import styles from "./LoginPage.module.scss";
// import mainImage from "../../assets/images/LogIn-Farm.png";
import mainImage from "../../assets/bg_login.png";
import logBigImg from "../../assets/logBigImg.png";
import logHeaderImg from "../../assets/logHeader.png";
import { useDispatch, useSelector } from "react-redux";
// import {ReactComponent as Logo} from '../../assets/images/logo-v3.png';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../../components/UI/input/input";
import Button from "../../components/UI/button/button";
import { login } from "../../thunk/login";



export function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const tokenFromStore = useSelector(
  //   (state) => state.auth.authData.accessToken
  // );

  const [data, setData] = useState({
    email: {
      val: "",
      required: true,
      error: false,
    },
    password: {
      val:'',
      required: true,
      error: false,
    },
  });


  const handleData = (val, key) => {
    setData((obj) => {
      return {...obj, [key]: {...obj[key], val} };
    });
  }

  const handleSave = () => {
    let isError = false;
    let req = {};

    for(let item of Object.keys(data)) {
      if(data[item].required) {
        if(!data[item].val) {
          setData((data) => {
            return {...data, [item]: {...data[item], error: true} };
          });
            isError = true;
        } else {
          setData((data) => {
            return {...data, [item]: {...data[item], error: false} };
          });
          req[item] = data[item].val;
          
        }
      } else { 
        req[item] = data[item].val;
      }
    }
    if(isError) return;
    dispatch(login(req)).then(data => {
      if(data === "ok") {
        navigate("/maps");
      }
    });
  }


  // useEffect(() => {
  //   if (tokenFromStore) {
  //     navigate("/devices");
  //   }
  // }, [tokenFromStore, navigate])
  return (
    <div className={styles.container}>
      <div className={styles.formPart}>
        <form className={styles.loginForm} >
          {/* <h2>Login</h2> */}
          <div className={styles.inputs}>
            <div className={styles.inputBlock}>
              <div className={styles.userNameInputContainer}>
                <span >Name</span>
                <Input 
                  handleChange={(e) => handleData(e.target.value, "email")}
                  error={data.email.error}
                />
              </div>
            </div>

            <div className={styles.inputBlock}>
              <div className={styles.userNameInputContainer}>
                <span >Password</span>
                <Input 
                  handleChange={(e) => handleData(e.target.value, "password")}
                  type="password"
                  error={data.password.error}
                />
              </div>
            </div>
          </div>

          <div className={styles.buttons}>
            <Button 
              title={"Login"}
              handleClick={handleSave}
            />
          </div>
        </form>
      </div>
      <div className={styles.imagePart}>
        <div className={styles.logBigImg}>
          <img src={logBigImg} alt="logBigImg" />
        </div>
        <div className={styles.logHeaderImg}>
          <img src={logHeaderImg} alt="logHeaderImg" />
        </div>
        <div className={styles.rightSideBg}></div>
        <div className={styles.logHeaderBg}></div>
        {/* <img
          src={mainImage}
          alt="mainImage"
        /> */}
      </div>
    </div>
  );
}

